import React from 'react';
import { IShapeProps } from './types';
import { IShapeLineAttributes } from '../../../types';
import { Group, Line } from 'react-konva';
import { LineCap } from 'konva/lib/Shape';
import Konva from 'konva';

const LineCanvasElement: React.FC<IShapeProps> = (props) => {

  let attributes = (props.element.attributes as IShapeLineAttributes);
  const shapeRef = (props.shapeRef as React.MutableRefObject<Konva.Line>);

  return (
    <>
    <Line
      {...props.renderProps}   
      hitStrokeWidth={30}   
      ref={shapeRef}
      lineCap={attributes.lineCap ? attributes.lineCap as LineCap : undefined}
      points={[0, 0, attributes.width!, 0]}
      
    />
    </>
  );
}

export default LineCanvasElement;